export default {
  nonBoxCatalogOptions: [
    { title: 'Más relevantes', value: 'relevance' },
    { title: 'Menor precio', value: 'lower_price' },
    { title: 'Mayor precio', value: 'higher_price' },
    { title: 'Más nuevas', value: 'newer' },
  ],
  boxCatalogOptions: [
    { title: 'Relevancia', value: 'relevance' },
    { title: 'Mejores calificaciones', value: 'rating' },
    { title: 'Cantidad de calificaciones', value: 'reviews_qty' },
    { title: 'Más nuevas', value: 'id' },
  ],
};
